import { FC, useEffect } from 'react'
import { ClbIcon, ClbButton } from '@celebration/react'
import { NxSvg } from '../../../components/svg'
import { NxHeading } from '../../../components/heading'
import { NxTooltip } from '../../../components/tooltip'
import { redirectLogin } from '..'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import {
  Brand,
  BrandName,
  Container,
  Content,
  Footer,
  LoginBox,
  LoginSubtitle,
  LoginTitle,
  LoginTitleIcon,
} from './styles/Login.styles'

const Login: FC = (): React.ReactElement => {
  const navigate = useNavigate()

  const isAuthenticated = useSelector((state: RootState) => state.auth.user.authenticated)

  useEffect(() => {
    if (isAuthenticated) navigate('/')
  }, [isAuthenticated, navigate])

  return (
    <>
      <Container>
        <Content>
          <Brand>
            <NxSvg name='Nexway' title='Logotipo da Nexway' />
            <BrandName size='2xl' type='h1'>
              TP Digital
            </BrandName>
          </Brand>
          <LoginBox>
            <LoginTitle>
              <NxHeading size='sm' type='h2'>
                Fazer login
              </NxHeading>
              <NxTooltip
                position='bottom'
                label={
                  'O SSO é um login único, ou seja, ele utiliza suas credenciais de outro sistema integrado para liberar seu acesso.'
                }
              >
                <LoginTitleIcon>
                  <ClbIcon size='sm' icon='info' />
                </LoginTitleIcon>
              </NxTooltip>
            </LoginTitle>
            <LoginSubtitle size='md' weight='600'>
              Acesse com suas credenciais
            </LoginSubtitle>
            <ClbButton
              type='button'
              styleType='primary'
              onClick={() => redirectLogin('Ambev')}
              size='md'
              label='SSO Ambev'
              aria-label='Entrar com o SSO Ambev'
            />
            <ClbButton
              type='button'
              styleType='secondary'
              onClick={() => redirectLogin('Third')}
              size='md'
              label='SSO Terceiros'
              aria-label='Entrar com o SSO Terceiro'
            />
          </LoginBox>
        </Content>
      </Container>
      <Footer />
    </>
  )
}

export default Login
